export default __webpack_public_path__ + "static/media/location-orange-icon.bc54c702.svg";